const VALIDATIONS = {
  BAD_REQUEST: (status = 0) => status === 400,
  FORBIDDEN: (status = 0) => status === 403,
  INTERNAL_ERROR: (status = 0) => status === 500,
  NOT_FOUND: (status = 0) => status === 404,
  OK: (status = 0) => status >= 200 && status < 300,
};

const STATUSES = {
  BAD_REQUEST: 'BAD_REQUEST',
  FORBIDDEN: 'FORBIDDEN',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  NOT_FOUND: 'NOT_FOUND',
  OK: 'OK',
};

function validStatuses(...rules) {
  /** @param {number} status */
  return (status) => {
    if (VALIDATIONS.OK(status)) {
      return true;
    }
    return rules.some((rule) => VALIDATIONS[rule](status));
  };
}

module.exports = {
  STATUSES,
  VALIDATIONS,
  validStatuses,
};
